module.exports = __webpack_public_path__ + "media/images/sample/product-10-123b40ea7ad50bf7490c2c804b9130ec.png";